<template>
  <v-layout row wrap>
    <v-flex xs12 class="px-0">
      <div v-for="(btn, b) in buttons" :key="b">
        <v-btn
          :color="selectedButton === b ? 'primary' : undefined"
          class="action-btn mx-0"
          block
          @click="handleClick(b)"
          :disabled="disabled"
        >
          {{ btn.text }}
        </v-btn>
        <v-avatar
          v-if="selectedButton === b"
          :disabled="disabled"
          class="delete-btn elevation-3"
          color="#f4f5f9"
          size="25"
          @click="removeButton(b)"
        >
          <i class="botter-trash-outline-icon red--text" />
        </v-avatar>
      </div>
    </v-flex>
    <v-flex xs12 v-if="type" class="px-0">
      <v-btn
        :disabled="!canAddButton || disabled"
        color="primary"
        class="add-btn"
        block
        flat
        @click="addButton"
      >
        <v-icon>add_circle</v-icon>
        <b>Add Button</b>
      </v-btn>
    </v-flex>
    <v-flex
      xs12
      class="px-0"
      v-if="
        type && buttons.length && items && items.length && items[selectedButton]
      "
    >
      <label class="grey--text font-weight-bold">Button Title</label>
      <v-text-field
        v-model="items[selectedButton].text"
        :disabled="disabled"
        placeholder="Button Title"
        class="field-width"
        outline
      />
    </v-flex>
    <v-flex
      xs12
      class="px-0"
      v-if="
        type &&
        buttons &&
        buttons.length &&
        buttons[selectedButton] &&
        buttons[selectedButton].type !== 'QUICK_REPLY'
      "
    >
      <label class="grey--text font-weight-bold">Button Actions</label><br />
      <v-btn-toggle
        v-model="items[selectedButton].type"
        :disabled="disabled"
        class="field-width"
        active-class="active-color"
        block
        @change="handleTypeChange"
      >
        <v-btn
          :disabled="disabled"
          value="URL"
          color="grey lighten-2"
          class="grey--text text--darken-3 action-toggle-btn afirst"
          style="border: 1px solid"
        >
          <v-icon>link</v-icon>
          URL
        </v-btn>
        <v-btn
          :disabled="disabled"
          value="PHONE_NUMBER"
          color="grey lighten-2"
          class="grey--text text--darken-3 action-toggle-btn alast"
        >
          <v-icon>phone</v-icon>
          Phone
        </v-btn>
      </v-btn-toggle>
    </v-flex>
    <v-flex
      xs12
      class="px-0 mt-2"
      v-if="
        type &&
        buttons &&
        items.length &&
        items[selectedButton] &&
        items[selectedButton].type !== 'QUICK_REPLY'
      "
    >
      <label class="grey--text font-weight-bold">
        {{ buttons[selectedButton].type === "URL" ? "URL" : "Phone Number" }}
      </label>
      <v-text-field
        v-model="items[selectedButton][resolveType(items[selectedButton].type)]"
        :disabled="disabled"
        :placeholder="
          buttons[selectedButton].type === 'URL' ? 'URL' : 'Phone Number'
        "
        class="field-width"
        outline
      />
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: "TemplateMessageButtons",
  props: {
    type: {
      type: String,
      default: null,
    },
    value: {
      type: [Object, Array],
      default() {
        return [];
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedButton: 0,
      items: [{ text: "Foo" }, { text: "Bar" }],
    };
  },
  watch: {
    type(val) {
      this.items = [];
      this.selectedButton = 0;
      if (val) {
        this.addButton();
      }
    },
    value: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val) {
          this.items = val;
        }
      },
    },
    buttons: {
      deep: true,
      handler(val) {
        this.$emit("input", val);
      },
    },
  },
  computed: {
    buttons() {
      return this.items;
    },
    canAddButton() {
      if (!this.type) return false;
      if (this.type === "quickReply" && this.buttons.length < 3) return true;
      if (this.type === "actions" && this.buttons.length < 2) return true;
      return false;
    },
    selectedButtonObject() {
      return this.items[this.selectedButton];
    },
  },
  methods: {
    resolveType(type) {
      return type === "URL" ? "url" : "phone_number";
    },
    handleClick(index) {
      this.selectedButton = index;
    },
    removeButton(index) {
      this.items.splice(index, 1);
      this.selectedButton = 0;
    },
    addButton() {
      if (this.canAddButton) {
        let item = {
          text: "Untitled Button",
          type: this.type === "quickReply" ? "QUICK_REPLY" : "URL",
        };
        if (item.type === "URL") item.URL = "";
        this.items.push(item);
      }
    },
    handleTypeChange(e) {
      let val = this.$_.pick(this.items[this.selectedButton], [
        e,
        "text",
        "type",
      ]);
      // if(!val[e]){
      // 	val[e] = ''
      // }
      this.$set(this.items, this.selectedButton, val);
    },
  },
};
</script>

<style lang="css" scoped>
.delete-btn {
  position: absolute;
  background-color: #f4f5f9;
  border-radius: 50%;
  cursor: pointer;
  padding: 4px;
  margin-left: 440px;
  margin-top: -38px;
}
.action-btn {
  width: 410px;
}
.add-btn {
  width: 410px;
}
.field-width {
  width: 450px;
}
.action-toggle-btn {
  width: 225px;
}
.action-toggle-btn.afirst {
  border-top-left-radius: 8px !important;
  border-bottom-left-radius: 8px !important;
}
.action-toggle-btn.alast {
  border-top-right-radius: 8px !important;
  border-bottom-right-radius: 8px !important;
}
.field-width >>> .v-btn--active {
  color: var(--primary) !important;
}
</style>
